import { Companion_getInstance2o9uk4k3kfl5 as Companion_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/uuid/Uuid.mjs';
import {
  toNotBlankString1ovj48s0kinvm as toNotBlankString,
  NotBlankString__toString_impl_5tex9r3bdt5aydt9d7j as NotBlankString__toString_impl_5tex9r,
  NotBlankString__hashCode_impl_fxqzj418fmehvdt9fzl as NotBlankString__hashCode_impl_fxqzj4,
  NotBlankString2t6vf2scdbmna as NotBlankString,
} from '../../../../../../types-types/kotools/types/text/NotBlankString.mjs';
import {
  throwOnFailure24snjmtlqgzo8 as throwOnFailure,
  _Result___get_value__impl__bjfvqg9vwgdwmhxc4m as _Result___get_value__impl__bjfvqg,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  equals2au1ep9vhcato as equals,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { PinTarget_Pair_getInstancec1tshbk9zqjw as PinTarget_Pair_getInstance } from './PinTarget.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      c2c() {
        // Inline function 'kotlin.getOrThrow' call
        var this_0 = toNotBlankString(Companion_getInstance().lu().toString());
        throwOnFailure(this_0);
        var tmp$ret$0 = _Result___get_value__impl__bjfvqg(this_0).b2b_1;
        return new (PinId())(tmp$ret$0);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  return Companion_instance;
}
var PinIdClass;
function PinId() {
  if (PinIdClass === VOID) {
    class $ {
      constructor(value) {
        this.q2f_1 = value;
      }
      toString() {
        return 'PinId(value=' + NotBlankString__toString_impl_5tex9r(this.q2f_1) + ')';
      }
      hashCode() {
        return NotBlankString__hashCode_impl_fxqzj4(this.q2f_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PinId()))
          return false;
        if (!equals(new (NotBlankString())(this.q2f_1), new (NotBlankString())(other.q2f_1)))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'PinId');
    PinIdClass = $;
  }
  return PinIdClass;
}
var PinClass;
function Pin() {
  if (PinClass === VOID) {
    class $ {
      constructor(id, name, icon, target) {
        name = name === VOID ? '' : name;
        icon = icon === VOID ? '' : icon;
        target = target === VOID ? PinTarget_Pair_getInstance() : target;
        this.r2f_1 = id;
        this.s2f_1 = name;
        this.t2f_1 = icon;
        this.u2f_1 = target;
      }
      v2f(id, name, icon, target) {
        return new (Pin())(id, name, icon, target);
      }
      w2f(id, name, icon, target, $super) {
        id = id === VOID ? this.r2f_1 : id;
        name = name === VOID ? this.s2f_1 : name;
        icon = icon === VOID ? this.t2f_1 : icon;
        target = target === VOID ? this.u2f_1 : target;
        return $super === VOID ? this.v2f(id, name, icon, target) : $super.v2f.call(this, id, name, icon, target);
      }
      toString() {
        return 'Pin(id=' + this.r2f_1.toString() + ', name=' + this.s2f_1 + ', icon=' + this.t2f_1 + ', target=' + this.u2f_1.toString() + ')';
      }
      hashCode() {
        var result = this.r2f_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.s2f_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.t2f_1) | 0;
        result = imul(result, 31) + this.u2f_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Pin()))
          return false;
        if (!this.r2f_1.equals(other.r2f_1))
          return false;
        if (!(this.s2f_1 === other.s2f_1))
          return false;
        if (!(this.t2f_1 === other.t2f_1))
          return false;
        if (!this.u2f_1.equals(other.u2f_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Pin');
    PinClass = $;
  }
  return PinClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  PinId as PinId3lhhfdu3qni8f,
  Pin as Pin34ndi4qc5y3vu,
  Companion_instance as Companion_instanceh7jilg8s7ljm,
};
//endregion

//# sourceMappingURL=Pin.mjs.map
